import React from "react";
import { Table } from "semantic-ui-react";
import "./styles.scss";

export default function LeaveManagementTable(props) {
    const { content, customTableClass, isClickItem, activeItem, onActiveItem, isUnStackable } = props;

    const handleClickItem = (idx) => () => {
        content.arrayValue && onActiveItem && onActiveItem(content.arrayValue[idx]);
    };

    return (
        <div className="leave-table">
            <Table sortable celled unstackable={isUnStackable} className={customTableClass}>
                {content.subHeader && (
                    <Table.Header fullWidth>
                        <Table.Row className="sub-header">
                            <Table.Cell colSpan={content.header.length}>{content.subHeader}</Table.Cell>
                        </Table.Row>
                    </Table.Header>
                )}
                <Table.Header>
                    <Table.Row className="main-header">
                        {content.header && content.header.map((ele, idx) => <Table.Cell key={idx}>{ele}</Table.Cell>)}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {content.body &&
                        content.body.map((eleParent, idxParent) => {
                            return (
                                <Table.Row
                                    key={idxParent}
                                    className={
                                        isClickItem
                                            ? `pointer-item ${
                                                  content.arrayValue &&
                                                  activeItem === content.arrayValue[idxParent] &&
                                                  "active-item"
                                              }`
                                            : ""
                                    }
                                    style={{
                                        background:
                                            content.colors && content.colors[idxParent]
                                                ? content.colors[idxParent]
                                                : "",
                                    }}
                                    onClick={handleClickItem(idxParent)}
                                >
                                    {eleParent.map((ele, idx) => (
                                        <Table.Cell
                                            key={idx}
                                            data-title={content.header[idx]}
                                            className={ele ? "" : "disable"}
                                        >
                                            {ele}
                                        </Table.Cell>
                                    ))}
                                </Table.Row>
                            );
                        })}
                </Table.Body>
            </Table>
        </div>
    );
}
